// extracted by mini-css-extract-plugin
module.exports = {"root":"root-xPlTh","title":"title-223oI","content":"content-1bzEa","text":"text-XuAWa","footer":"footer-1-S_B","types":"types-dOB2d"};